import React from "react";
import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import { ReactComponent as SuccessCheck } from "../../assets/success_apply.svg";
import { ReactComponent as CloseBtn } from "../../assets/modal_close.svg";

interface Props {
  close: () => void;
}
const SuccessApplyModal: React.FC<Props> = (props) => {
  const mode = DisplayType();
  const { t } = useLanguage();
  const message = t("modal", "applySuccess.detailDesktop");
  return (
    <Container>
      <ContentsContainer>
        {mode !== "Mobile" && (
          <CloseBtn className="close__btn" onClick={props.close} />
        )}
        <SuccessCheck />
        <div
          className={`success__apply__title ${
            mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
          }`}
        >
          {t("modal", "applySuccess.title")}
        </div>
        {mode === "Mobile" ? (
          <p className={`success__apply__content font-body4 `}>
            {renderText(t("modal", "applySuccess.detailMobile"))}
          </p>
        ) : (
          <pre className={`success__apply__content font-body2`}>{message}</pre>
        )}
      </ContentsContainer>
      {mode === "Mobile" && (
        <div className="mobile__close" onClick={props.close}>
          {t("modal", "applySuccess.button")}
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .mobile__close {
    width: 100%;
    height: 56px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--grey-00);
    color: var(--primary);
  }
`;

const ContentsContainer = styled.div`
  position: relative;
  width: 1060px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 80px;

  .close__btn {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 48px;
    height: 48px;
    cursor: pointer;
    background-color: transparent;
    transition: background-color 0.2s ease-in;
    border-radius: 8px;
    :hover {
      background-color: var(--grey-00);
    }
  }

  .success__apply__title {
    text-align: center;
  }
  .success__apply__content {
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    width: calc(100vw - 64px);
    padding: 40px 24px;

    .success__apply__title {
      text-align: center;
    }
    .success__apply__content {
      text-align: start;
      width: 100%;
    }
  }
`;

export default React.memo(SuccessApplyModal);
